<template>
  <v-select
    id="temas-select"
    v-model ="filter.regra"
    item-text ="nome"
    item-name ="nome"
    item-value ="temaId"
    :items="temas"
    label ="Regra"
    placeholder ="Regra"
    v-on:change ="$emit('onChange')"
    :disabled = "disabled"
  >
    <template slot="no-data">
      Nenhum Tema
    </template>
  </v-select>
</template>

<script>
import { medalhaAPI } from '../API/Medalha'
import { mapActions } from 'vuex'

export default {
  name: 'AppTemasCombobox',
  props: {
    filter: { type: Object },
    disabled: { type: Boolean, default: false }
  },
  mounted () {
    this.filter.regra = parseInt(this.filter.regra)
    this.loadTemas()
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    loadTemas () {
      medalhaAPI.getTemas()
        .then(resp => {
          this.temas = resp.data
        })
        .catch()
    }
  },
  data () {
    return {
      temas: []
    }
  }
}
</script>
